export const accordion = (function ($) {

    let $accordion = $('.js-toggle-accordion');

    function toggleAccordion ($this) {
        if ($this.parent().hasClass('is-open')) {
            $this.parent().removeClass('is-open');
            $this.next(".accordion__inner").css("max-height", "0px");
        } else {
            // first close all other adjacent accordions
            let $accordionAdjacent = $this.parent().parent().find('.js-toggle-accordion');

            $accordionAdjacent.parent().removeClass('is-open');
            $accordionAdjacent.next(".accordion__inner").css("max-height", "0px");

            // then open the clicked one
            $this.parent().addClass('is-open');
            $this.next(".accordion__inner").css("max-height", $this.next(".accordion__inner").find(".accordion__content").innerHeight() + "px");

            if ($this.hasClass('js-accordion-anchor')) {
                setTimeout(() => {
                    // scroll to accordion
                    $("html,body").animate({
                        scrollTop: $this.offset().top - 50,
                    }, 0);
                }, 400);
            }
        }
    }

    function init() {
        $accordion.click(function (e) {
            e.preventDefault();
            let $this = $(this);

            toggleAccordion($this);
        });
    }

    return {
        init: init
    }

})(jQuery);